import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import Card from "../../../../../components/Card/Card";
import CardBody from "../../../../../components/Card/CardBody";
import { Collapse, Grid, IconButton, List, ListItem, MenuItem, Select, TextField } from "@mui/material";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";
import { Delete } from "@mui/icons-material";
import React from "react";
import Button from "../../../../../components/CustomButtons/Button";
import FormTextTC from "../../../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../../../components/Forms/FormSwitchTC";

type Answer = { type: "APPROVED" | "DENIED"; text: string };

type FormValues = {
  custom_data: { order_confirmations: { alcohol_confirmation: { answers: Array<Answer> } } };
};
export default function AgeCheckShoppingCartConfirmation() {
  const { control } = useFormContext<FormValues>();
  const enabled = useWatch({ name: "custom_data.order_confirmations.alcohol_confirmation.enabled" });
  const { fields, replace, update, append, prepend, remove, swap, move, insert } = useFieldArray<
    FormValues,
    "custom_data.order_confirmations.alcohol_confirmation.answers",
    "key"
  >({
    control,
    name: "custom_data.order_confirmations.alcohol_confirmation.answers",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <List
              sx={{
                "& li:nth-child(even)": {
                  backgroundColor: "#eee",
                },
              }}
            >
              <ListItem>
                <Grid container>
                  <Grid item xs={6}>
                    <h3>
                      <TranslationWrapper tKey={"Age Check Shoppingcart Confirmation using Jamezz KitchenScreen"} />
                    </h3>
                  </Grid>
                  <Grid item xs={6} />
                </Grid>
              </ListItem>

              <FormSwitchTC
                name={"custom_data.order_confirmations.alcohol_confirmation.enabled"}
                tDefault={"Enabled"}
                tKey={"custom_data.order_confirmations.alcohol_confirmation.enabled"}
              />
              <Collapse in={enabled}>
                <FormTextTC
                  name={"custom_data.order_confirmations.alcohol_confirmation.question.en"}
                  tDefault={"Question to be asked?"}
                  tKey={"custom_data.order_confirmations.alcohol_confirmation.question.en"}
                />
                {fields.map((field, index) => {
                  return (
                    <ListItem>
                      <Grid container>
                        <Grid item sx={{ display: "grid", alignItems: "center" }} xs={4}>
                          <Select
                            onChange={(e) => {
                              update(index, { type: e.target.value as "APPROVED" | "DENIED", text: field.text });
                            }}
                            value={field.type}
                          >
                            <MenuItem value={"APPROVED"}>Approved</MenuItem>
                            <MenuItem value={"DENIED"}>Denied</MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sx={{ display: "grid", alignItems: "center" }} xs={4}>
                          <TextField
                            onChange={(e) => {
                              update(index, { type: field.type, text: e.target.value });
                            }}
                            value={field.text}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <IconButton
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </ListItem>
                  );
                })}

                <Button
                  onClick={() => {
                    append({ type: "DENIED", text: "Enter reason" });
                  }}
                >
                  Add option
                </Button>
              </Collapse>
            </List>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
}
